import { Divider, Form, Input } from "antd";
import "../styles.css";
import TextArea from "antd/es/input/TextArea";
import "../../../../components/modals/invitations/styles.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const TagCardEdit = ({ task: tag, form }) => {
  const { t } = useTranslation();

  useEffect(() => {
    form.setFieldsValue({
      name: tag?.name || "",
      description: tag?.description || "",
    });
  }, [tag, form]);

  return (
    <div
      className="tags-modal"
      style={{ position: "relative", bottom: 16 }}
    >
      <Divider />
      <Form form={form}>
        <Form.Item key={"name"}>
          <div className="invite-user__field">
            <p className="invite-user__field__name">
              {t(`tags.modal.name`)}
            </p>
            <Form.Item name={"name"} noStyle>
              <Input
                placeholder={t(`tags.placeholders.tag_name`)}
                variant="borderless"
                className="tags-drawer__body__title"
                maxLength={256}
              />
            </Form.Item>
          </div>
        </Form.Item>
        <Form.Item key={"description"}>
          <div className="invite-user__field">
            <p className="invite-user__field__name">
              {t(`tags.modal.description`)}
            </p>
            <Form.Item name={"description"} noStyle>
              <TextArea
                placeholder={t(`tags.placeholders.tag_description`)}
                variant="borderless"
                className="tags-drawer__body__description"
                maxLength={1000}
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Form>
      <Divider style={{ margin: 0 }} />
    </div>
  );
};

export default TagCardEdit;
